import { useEffect } from "react";
import axiosInstance from "../axiosConfig";

const LiveLocationTracker = () => {
    useEffect(() => {
        const updateLocation = async () => {
            if (navigator.geolocation) {
                // Get the list of all users first
                try {
                    const response = await axiosInstance.get("user/"); // Assuming an endpoint to fetch all users
                    const users = response.data;

                    // Get the current location and update for each user
                    navigator.geolocation.getCurrentPosition(
                        async (position) => {
                            const { latitude, longitude } = position.coords;

                            // Prepare the data structure for all users
                            const locationData = users.map((user) => ({
                                user_id: user.id, // Assuming users have an `id` field
                                latitude: latitude,
                                longitude: longitude,
                            }));

                            // Send the list of all user locations to the backend
                            try {
                                await axiosInstance.post("location/live/update/", locationData);
                                console.log("Location updated successfully for all users");
                            } catch (error) {
                                console.error("Error updating location:", error);
                            }
                        },
                        (error) => console.error("Error getting location:", error),
                        { enableHighAccuracy: true }
                    );
                } catch (error) {
                    console.error("Error fetching users:", error);
                }
            }
        };

        updateLocation();
        const interval = setInterval(updateLocation, 60000); // Update every 1 minute
        return () => clearInterval(interval);
    }, []);

    return null; // No UI needed
};

export default LiveLocationTracker;
